import FooterLink from "../../../../../../packages/design-system/src/FooterLink";
import Spacings from "../../../../../../packages/design-system/src/Spacings";
import * as React from 'react';
export default {
  FooterLink,
  Spacings,
  React
};